import * as Recharts from 'recharts';

import { YAxisTick } from './Ticks';

export class YAxis extends Recharts.YAxis {
  static defaultProps = {
    ...Recharts.YAxis.defaultProps,
    axisLine: false,
    tickLine: false,
    tick: YAxisTick,
    type: 'number',
  };
}

export default YAxis;
